import SkipLink from '@/components/SkipLink'
import Footer from '@/layout/Footer'
import Navbar from '@/layout/Navbar'
import HeadTags from '@/lib/head/HeadTags'
import skipTargetProps from '@/utils/a11y/skipTargetProps'

import FoodGrubhubDefaultContent from './components/FoodGrubhubDefaultContent/FoodGrubhubDefaultContent'
import FoodGrubhubSearchResult from './components/FoodGrubhubSearchResult/FoodGrubhubSearchResult'
import style from './FoodGrubhub.module.scss'

const FoodGrubhub = () => {
  const location = useLocation()

  const isSearch = location.searchStr !== ''
  return (
    <div>
      <HeadTags title='Food & Grocery' />
      <SkipLink title='Skip to main content' to='#main-content' />
      <Navbar variant='dark' />
      <main {...skipTargetProps('main-content')} className={style.Page}>
        {!isSearch && <FoodGrubhubDefaultContent />}
        {isSearch && (
          <Suspense fallback={null}>
            <FoodGrubhubSearchResult />
          </Suspense>
        )}
      </main>

      <Suspense>
        <Footer />
      </Suspense>
    </div>
  )
}

export default FoodGrubhub
